var _style, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "Icon-fill-color",
    d: "M11.8 16c-.4 0-.8-.3-.8-.8V1.8c0-.5.3-.8.8-.8s.8.3.8.8v13.5c-.1.4-.4.7-.8.7z",
    stroke: "transparent"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "Icon-fill-color",
    d: "M16.6 6.5c-.3.3-.8.3-1.1 0L11 1.9c-.3-.3-.3-.8 0-1.1.3-.3.8-.3 1.1 0l4.6 4.6c.2.4.2.8-.1 1.1z",
    stroke: "transparent"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "Icon-fill-color",
    d: "M6.4 6.5c.3.3.8.3 1.1 0L12 1.9c.3-.3.3-.8 0-1.1-.3-.3-.8-.3-1.1 0L6.4 5.5c-.3.3-.3.7 0 1zm-.9 4.3c-.7 0-1.2.6-1.2 1.2v8c0 .7.6 1.2 1.2 1.2h12c.7 0 1.2-.6 1.2-1.2v-8c0-.7-.6-1.2-1.2-1.2h-2c-.4 0-.7-.3-.7-.8 0-.4.3-.8.7-.8h2c1.5 0 2.8 1.2 2.8 2.8v8c0 1.5-1.2 2.8-2.8 2.8h-12c-1.5 0-2.8-1.2-2.8-2.8v-8c0-1.5 1.2-2.8 2.8-2.8h2c.4 0 .8.3.8.8 0 .4-.3.8-.8.8h-2z",
    stroke: "transparent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/Share.da29d7b2f62bfe37e68b667785306ffb.svg";
export { ForwardRef as ReactComponent };